export default {
  'app.settings.menuMap.security': '安全设置',
  'app.settings.menuMap.timezone': '时区设置',
  'app.settings.actions.modify': '修改',
  'app.settings.password.title': '登录密码',
  'app.settings.resetpassword.title': '重置登录密码',
  'app.settings.password.description': '为了确保密码安全请定期修改！',
  'app.settings.paypass.title': '支付密码',
  'app.settings.resetpaypass.title': '重置支付密码',
  'app.settings.paypass.description': '为了确保密码安全请定期修改！',
  'app.settings.secret.title': '谷歌验证码',
  'app.settings.resetsecret.title': '重置谷歌验证码',
  'app.settings.secret.description': '请保存好你的谷歌密钥！',

  'app.settings.menuMap.hashkey': 'Hash密钥设置',
  'app.settings.menuMap.rsakey': 'Rsa密钥设置',
  'app.settings.label.hashkey': 'Hash密钥',
  'app.settings.label.platformrsapublickey': '平台Rsa公钥',
  'app.settings.label.merchantrsapublickey': '商户Rsa公钥',
  'app.settings.label.merchantrsaprivatekey': '商户Rsa私钥',

  'app.settings.label.loginduration': '登录时长设置',
  'app.settings.label.timezone': '时区设置',
};
